import { create } from 'zustand';
import { checkQuestionAccess, getQuestionDetails } from '../services/questions.api';

const useLabQuestionStore = create((set) => ({
  accessMap: {}, // key: `${labInternalId}:${questionId}` -> { authorized, reason }
  questions: {}, // key: `${labInternalId}:${questionId}` -> question details
  loading: false,
  error: null,

  async checkAccess(labInternalId, questionId) {
    set({ loading: true, error: null });
    try {
      const res = await checkQuestionAccess(labInternalId, questionId);
      const payload = res?.data || res;
      const authorized = Boolean(payload?.authorized);
      const reason = payload?.reason || null;
      const key = `${labInternalId}:${questionId}`;
      set((state) => ({
        accessMap: { ...state.accessMap, [key]: { authorized, reason } },
        loading: false,
      }));
      return { authorized, reason };
    } catch (err) {
      set({ error: err, loading: false });
      throw err;
    }
  },

  async fetchDetails(labInternalId, questionId) {
    set({ loading: true, error: null });
    try {
      const res = await getQuestionDetails(labInternalId, questionId);
      const key = `${labInternalId}:${questionId}`;
      set((state) => ({
        questions: { ...state.questions, [key]: res },
        loading: false,
      }));
      return res;
    } catch (err) {
      set({ error: err, loading: false });
      throw err;
    }
  },
}));

export default useLabQuestionStore;
